export const BASE_URL = 'https://api.vrwoodong.com';
export const LOCAL_BASE_URL = 'http://localhost:4130';
export const FILE_BASE_URL = 'https://file.vrwoodong.com';
export const IMAGE_MAX_SIZE = 10 * 1024 * 1024;
